// # ----------------------------------------------------------------------------------------- #
// # MAIN SCRIPTS
// # ----------------------------------------------------------------------------------------- #

// Import scss main style files
import '../scss/main.scss';

// Global imports
import './helpers.js';

// Component imports
import SummaryPositions from './components/SummaryPositions.js';
import ScrollingNumber from './components/ScrollingNumber.js';
import SiteHeader from './components/Layouts/SiteHeader.js';
import SiteFilter from './components/Layouts/SiteFilter.js';
import ShortcutButton from './components/ShortcutButton.js';
import BlockMap from './components/BlockMap.js';
import SliderIcons from './components/Sliders/SliderIcons.js';
import SliderKeyFigures from './components/Sliders/SliderKeyFigures.js';
import SliderImages from './components/Sliders/SliderImages.js';
import SliderPostTypes from './components/Sliders/SliderPostTypes.js';
import SliderCreative from './components/Sliders/SliderCreative.js';
import TabulationNavigationSlider from './components/Sliders/TabulationNavigationSlider.js';
import ExpertisesCard from './components/ExpertisesCard.js';
import TextAnimationOnScroll from './components/Animations/TextAnimationOnScroll.js';
import TextAnimationOnHover from './components/Animations/TextAnimationOnHover.js';
import ObserverAnimation from './components/Animations/ObserverAnimation.js';
import Masonry from './components/Masonry.js';
import StickyColumn from './components/StickyColumn.js';
import SliderBusinessCases from './components/Sliders/SliderBusinessCases.js';
import DynamicCards from './components/DynamicCards.js';
import IconsGrid from './components/IconsGrid.js';
import VideoElement from './components/VideoElement.js';
import SingleWhiteBook from './components/Pages/SingleWhiteBook.js';
import SingleGuide from './components/Pages/SingleGuide.js';
import FormProgressBar from './components/Forms/FormProgressBar.js';
import FormOutputMessage from './components/Forms/FormOutputMessage.js';
import FormSelect from './components/Forms/FormSelect.js';
import FormUtmHiddenField from './components/Forms/FormUtmHiddenField.js';
import FormEvent from './components/Forms/FormEvent.js';
import CaptchaComponent from './components/Forms/CaptchaComponent.js';
import WelcomeToTheJungleJobs from './components/WelcomeToTheJungleJobs.js';
import SearchFull from '@/js/components/Pages/SearchFull.js';
import SearchWithAutocomplete from '@/js/components/Forms/SearchWithAutocomplete.js';
import BasePopIn from '@/js/components/PopIns/BasePopIn.js';
import MouseTiltAnimation from '@/js/components/Animations/MouseTiltAnimation.js';

// # ----------------------------------------------------------------------------------------- #
// # Fill the array with the components needed right after the page fully loaded
// # ----------------------------------------------------------------------------------------- #
const componentsOnLoad = () => {
  [
    // For example : header behavior, form validation, swiper generation, etc.
    new SiteHeader(),
    new SearchFull(),
    new SearchWithAutocomplete(),
    new CaptchaComponent(),
    new SiteFilter(),
    new DynamicCards(),
    new SummaryPositions(),
    new ScrollingNumber(),
    new BlockMap(),
    new SliderIcons(),
    new SliderKeyFigures(),
    new TabulationNavigationSlider(),
    new SliderImages(),
    new SliderPostTypes(),
    new SliderCreative(),
    new SliderBusinessCases(),
    new ExpertisesCard(),
    new TextAnimationOnScroll(),
    new TextAnimationOnHover(),
    new ObserverAnimation(),
    new MouseTiltAnimation(),
    new Masonry(),
    new StickyColumn(),
    new IconsGrid(),
    new VideoElement(),
    new SingleWhiteBook(),
    new SingleGuide(),
    new ShortcutButton(),
    new FormProgressBar(),
    new FormOutputMessage(),
    new FormSelect(),
    new FormUtmHiddenField(),
    new FormEvent(),
    new WelcomeToTheJungleJobs(),
    new BasePopIn(),
  ].forEach((component) => component.init());
};

// # ----------------------------------------------------------------------------------------- #
// # DEFAULT EVENTS
// # ----------------------------------------------------------------------------------------- #

window.addEventListener(
  'load',
  () => {
    componentsOnLoad();
  },
  window.supportPassive
);

// # ----------------------------------------------------------------------------------------- #
// # Fill the array with the components needed right after one of the action
// # ----------------------------------------------------------------------------------------- #
// const componentsOnUserEvent = () => {
//   [
//     // For example : components impacting performances, like cookie banner, etc..
//   ].forEach((component) => component.init());
//
//   window.removeEventListener('scroll', componentsOnUserEvent);
//   window.removeEventListener('wheel', componentsOnUserEvent);
//   window.removeEventListener('touchstart', componentsOnUserEvent);
//   window.removeEventListener('mouseover', componentsOnUserEvent);
// };

// window.addEventListener('scroll', componentsOnUserEvent, window.supportPassive);
// window.addEventListener('wheel', componentsOnUserEvent, window.supportPassive);
// window.addEventListener(
//   'mouseover',
//   componentsOnUserEvent,
//   window.supportPassive
// );
// window.addEventListener(
//   'touchstart',
//   componentsOnUserEvent,
//   window.supportPassive
// );
